export enum LoaderType {
	OnScreen,
	OverScreen,
}

export type LoaderProps = {
	isToShowLoader: boolean;
	type: LoaderType;
};
